import { useCallback } from "react";

export const useMoveBySwiping = ({
	minDelta,
	moveLeft,
	moveRight,
	onUnderThreshold = undefined,
}) => {
	const handleSwipe = useCallback(
		({ deltaX, deltaY }) => {
			if (minDelta < 0) {
				console.error("[useMoveBySwiping] minDelta should be greater than 0");
				return;
			}

			const wentOverThresholdX = Math.abs(deltaX) >= minDelta;
			const wentOverThresholdY = Math.abs(deltaY) >= minDelta;

			const wentOverThreshold = wentOverThresholdX || wentOverThresholdY;

			if (!wentOverThreshold) {
				onUnderThreshold && onUnderThreshold();
				return;
			}

			if (!wentOverThresholdX) {
				return;
			}

			// threshold x
			const isGoingRight = deltaX > 0;

			if (isGoingRight) {
				moveLeft();
			} else {
				moveRight();
			}
		},
		[moveLeft, moveRight, minDelta, onUnderThreshold]
	);

	return {
		handleSwipe,
	};
};
